import Constants from 'expo-constants';

export class AppVersionWrapper {
  static getBuildVersion(): string | null {
    // Expo SDK 49+ exposes config via Constants.expoConfig on all platforms.
    // Keep a couple fallbacks for older/edge environments.
    const version =
      Constants.expoConfig?.version ??
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Constants as any)?.manifest?.version ??
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Constants as any)?.manifest2?.extra?.expoClient?.version ??
      null;

    return typeof version === 'string' && version.trim().length > 0
      ? version.trim()
      : null;
  }
}

export const appVersion = AppVersionWrapper;

